import {
  TaskTemplateServiceTemplateQuery,
  SitePageContext,
} from "../../../graphql-types";
import { pp } from "../../shared/utilities/pretty-print";
import { TaskTemplateServiceBreadcrumbsProps } from "./TaskTemplateService/TaskTemplateServiceBreadcrumbs";

interface SelectTaskTemplateServiceBreadcrumbsPropsArgs {
  data: TaskTemplateServiceTemplateQuery;
  pageContext: SitePageContext;
}

export function selectTaskTemplateServiceBreadcrumbsProps({
  data,
  pageContext,
}: SelectTaskTemplateServiceBreadcrumbsPropsArgs): TaskTemplateServiceBreadcrumbsProps {
  if (data.taskTemplateServicePage?.marketingGroupIndexPath == null) {
    throw Error(
      `data.taskTemplateServicePage?.marketingGroupIndexPath is null: ${pp({
        data,
      })}`
    );
  }
  if (data.taskTemplateServicePage?.marketingGroupTitle == null) {
    throw Error(
      `data.taskTemplateServicePage?.marketingGroupTitle is null: ${pp({
        data,
      })}`
    );
  }
  if (data.taskTemplateServicePage?.path == null) {
    throw Error(`data.taskTemplateServicePage?.path is null: ${pp({ data })}`);
  }
  if (data.taskTemplateServicePage?.serviceIndexPath == null) {
    throw Error(
      `data.taskTemplateServicePage?.serviceIndexPath is null: ${pp({ data })}`
    );
  }
  if (data.taskTemplateServicePage?.templateName == null) {
    throw Error(
      `data.taskTemplateServicePage?.templateName is null: ${pp({ data })}`
    );
  }
  if (pageContext.origin == null) {
    throw Error(`pageContext.origin is null: ${pp({ pageContext })}`);
  }

  return {
    marketingGroupIndexPath:
      data.taskTemplateServicePage.marketingGroupIndexPath,
    marketingGroupTitle: data.taskTemplateServicePage.marketingGroupTitle,
    origin: pageContext.origin,
    path: data.taskTemplateServicePage.path,
    serviceIndexPath: data.taskTemplateServicePage.serviceIndexPath,
    templateName: data.taskTemplateServicePage.templateName,
  };
}
